exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star {\r\n    color: red;\r\n}\r\ninput.ng-invalid.ng-touched{\r\n    border: 2px solid red;\r\n}\r\n\r\n.msg-error{\r\n    color: red;\r\n}\r\n.modal-dialog {\r\n    width: 800px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/telegram-channel/add-telegram-channel/add-telegram-channel.component.css
// module id = ../../../../../src/app/_components/telegram-channel/add-telegram-channel/add-telegram-channel.component.css
// module chunks = main